// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding: 10% 2%;
}
.card_wrapper .card {
  max-width: 45%;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  margin-bottom: 19px;
  border-radius: 3px;
  height: -moz-fit-content;
  height: fit-content;
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset;
  background: #fff2e5;
}
.card_wrapper .card img {
  width: 100%;
  max-height: inherit;
  margin-bottom: 10px;
}
.card_wrapper .card .card_name {
  font-size: 12px;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
  font-weight: bold;
  margin: 10px;
  margin-left: 6px;
  color: #82776d;
}
.card_wrapper .card label {
  overflow: hidden;
  font-size: 13px;
  color: #baada2;
}
.card_wrapper .card .see_more {
  width: 100%;
  text-align: center;
  cursor: pointer;
  margin-top: 18px;
  margin-right: auto;
  margin-left: auto;
  display: block;
  text-transform: lowercase;
  font-size: 11px;
  color: #888888;
}

.xl_title {
  text-align: center;
  margin: 20px 0;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
  text-decoration: underline;
  color: #bba599;
}

.search_txt {
  text-align: center;
  color: #bba599;
  opacity: 0.8;
  margin-top: 5vh;
  font-size: 12px;
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}
.search_txt b {
  opacity: 1;
  font-weight: 800;
}

.right_icon {
  float: right;
  font-size: 21px;
  color: #242424;
  margin-top: -30px;
}

.card_searcher {
  border-bottom: 1px solid #ededed;
}

.totalItemCount {
  text-align: center;
  font-size: 14px;
  width: 100%;
  display: block;
  color: #bba599;
}

.tags ion-chip {
  text-align: left;
  color: #d4c3ba;
  border-color: #d4c3ba;
}
.tags .filled {
  background: #bba599;
  color: #fff;
}
.tags ion-label {
  font-size: 12px;
}

.flex_form_baby {
  display: inline-flex;
  width: 100%;
}
.flex_form_baby form {
  width: 100%;
}
.flex_form_baby ion-buttons {
  height: 38px;
}
.flex_form_baby .within_tag {
  display: inline-flex;
  justify-content: space-between;
  background: #d2b094;
  color: #fff2e6;
  padding: 8px;
  margin-top: 2px;
  margin-left: 10px;
  box-sizing: border-box;
  border-radius: 4px;
  grid-gap: 6px;
  height: -moz-fit-content;
  height: fit-content;
  cursor: pointer;
}
.flex_form_baby .within_tag label {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 113px;
}
.flex_form_baby .within_tag ion-icon {
  color: #fff2e6;
  font-size: 16px !important;
  padding-top: 0;
}

.search-results {
  position: absolute;
  width: 81%;
  left: 0;
  right: 0;
  display: block;
  margin: auto;
  top: 64px;
  z-index: 9000;
  border-radius: 10px;
}
.search-results ion-list {
  border-radius: 6px;
}
.search-results ion-list ion-item {
  --inner-border-width: 0 !important;
  background: #ede2d6 !important;
  cursor: pointer;
}
.search-results ion-list ion-item ion-label {
  color: #aaa5a1 !important;
  white-space: no-wrap;
}

.dimmer {
  position: absolute;
  z-index: 9000;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.setSuggestionWrapper {
  margin-top: 5vh;
  text-align: left;
}
.setSuggestionWrapper .searchPlace {
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
}
.setSuggestionWrapper .searchPlace button {
  padding: 8px;
  margin: 0px;
  height: -moz-fit-content;
  height: fit-content;
  border-radius: 3px;
  font-size: 10px;
  margin-top: 10px;
  background: #cab0a5;
  color: #fff5ea;
}
.setSuggestionWrapper .searchPlace h3 {
  font-size: 12px;
  margin-left: 10px;
}
.setSuggestionWrapper .setSuggestion {
  text-align: left;
  background: #fff2e6;
  color: #a0776b;
  border: 1px dotted #d2b094;
  border-left: 4px solid;
  border-right: 4px solid;
  margin: 3px 0;
  padding: 18px;
  border-radius: 4px;
  display: inline-flex;
  width: 100%;
  justify-content: space-between;
  opacity: 0.7;
  cursor: pointer;
}
.setSuggestionWrapper .setSuggestion ion-label {
  font-weight: 900;
}
.setSuggestionWrapper .setSuggestion ion-label ion-icon {
  width: 30px;
  font-size: 21px;
}
.setSuggestionWrapper .setSuggestion label {
  cursor: pointer;
}

.caretDown {
  font-size: 21px !important;
  padding-top: 7px;
  width: 50px;
}

.empty_block {
  height: 100px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/search-category/search-category.page.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;EACA,6BAAA;EACA,eAAA;AACJ;AACI;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,sBAAA;EACA,qDAAA;EACA,mBAAA;AACR;AACQ;EACI,WAAA;EACA,mBAAA;EACA,mBAAA;AACZ;AAEQ;EACI,eAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AAAZ;AAGQ;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AADZ;AAIQ;EACI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;AAFZ;;AAOA;EACI,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,0BAAA;EACA,cAAA;AAJJ;;AAMA;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;AAKI;EACI,UAAA;EACA,gBAAA;AAHR;;AAOA;EACI,YAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAJJ;;AAeA;EAEI,gCAAA;AAbJ;;AAgBA;EACI,kBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AAbJ;;AAmBI;EACI,gBAAA;EACA,cAAA;EACA,qBAAA;AAhBR;AA0BI;EACI,mBAAA;EACA,WAAA;AAxBR;AA2BI;EACI,eAAA;AAzBR;;AA6BA;EACI,oBAAA;EACA,WAAA;AA1BJ;AA4BI;EACI,WAAA;AA1BR;AA6BI;EACI,YAAA;AA3BR;AA8BI;EACI,oBAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,wBAAA;EAAA,mBAAA;EACA,eAAA;AA5BR;AA8BQ;EACI,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AA5BZ;AA+BQ;EACI,cAAA;EACA,0BAAA;EACA,cAAA;AA7BZ;;AAkCA;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AA/BJ;AAiCI;EACI,kBAAA;AA/BR;AAiCQ;EACI,kCAAA;EACA,8BAAA;EACA,eAAA;AA/BZ;AAiCY;EACI,yBAAA;EACA,oBAAA;AA/BhB;;AAqCA;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;AAlCJ;;AAqCA;EACI,eAAA;EACA,gBAAA;AAlCJ;AAoCI;EACI,WAAA;EACA,oBAAA;EACA,8BAAA;AAlCR;AAoCQ;EACI,YAAA;EACA,WAAA;EACA,wBAAA;EAAA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAlCZ;AAqCQ;EACI,eAAA;EACA,iBAAA;AAnCZ;AAuCI;EACI,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AArCR;AAuCQ;EACI,gBAAA;AArCZ;AAuCY;EACI,WAAA;EACA,eAAA;AArChB;AAyCQ;EACI,eAAA;AAvCZ;;AA4CA;EACI,0BAAA;EACA,gBAAA;EACA,WAAA;AAzCJ;;AA4CA;EACI,aAAA;EACA,WAAA;AAzCJ","sourcesContent":[".card_wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-evenly;\n    padding: 10% 2%;\n\n    .card {\n        max-width: 45%;\n        margin-left: auto;\n        margin-right: auto;\n        padding: 10px;\n        margin-bottom: 19px;\n        border-radius: 3px;\n        height: fit-content;\n        box-sizing: border-box;\n        box-shadow: rgb(0 0 0 / 6%) 0px 2px 4px 0px inset;\n        background: #fff2e5;\n\n        img {\n            width: 100%;\n            max-height: inherit;\n            margin-bottom: 10px;\n        }\n\n        .card_name {\n            font-size: 12px;\n            text-overflow: ellipsis;\n            max-width: 100%;\n            overflow: hidden;\n            font-weight: bold;\n            margin: 10px;\n            margin-left: 6px;\n            color: #82776d;\n        }\n\n        label {\n            overflow: hidden;\n            font-size: 13px;\n            color: #baada2;\n        }\n\n        .see_more {\n            width: 100%;\n            text-align: center;\n            cursor: pointer;\n            margin-top: 18px;\n            margin-right: auto;\n            margin-left: auto;\n            display: block;\n            text-transform: lowercase;\n            font-size: 11px;\n            color: #888888;\n        }\n    }\n}\n\n.xl_title {\n    text-align: center;\n    margin: 20px 0;\n    font-weight: bold;\n    text-transform: uppercase;\n    font-size: 14px;\n    text-decoration: underline;\n    color: #bba599;\n}\n.search_txt {\n    text-align: center;\n    color: #bba599;\n    opacity: 0.8;\n    margin-top: 5vh;\n    font-size: 12px;\n    width: 70%;\n    margin-left: auto;\n    margin-right: auto;\n\n    b {\n        opacity: 1;\n        font-weight: 800;\n    }\n}\n\n.right_icon {\n    float: right;\n    font-size: 21px;\n    color: #242424;\n    margin-top: -30px;\n}\n\n// .card_searcher * {\n//     font-size: 12px;\n// }\n\n// ion-content {\n//     --background: white !important;\n// }\n\n.card_searcher {\n    //--background: white !important;\n    border-bottom: 1px solid #ededed;\n}\n\n.totalItemCount {\n    text-align: center;\n    font-size: 14px;\n    width: 100%;\n    display: block;\n    color: #bba599;\n}\n\n.tags {\n    //margin-top: 12px;\n\n    ion-chip {\n        text-align: left;\n        color: #d4c3ba;\n        border-color: #d4c3ba;\n\n        // white-space: nowrap;\n        // text-overflow: ellipsis;\n\n        // max-width: 150px;\n        // max-height: 120px;\n        // overflow: scroll;\n    }\n\n    .filled {\n        background: #bba599;\n        color: #fff;\n    }\n\n    ion-label {\n        font-size: 12px;\n    }\n}\n\n.flex_form_baby {\n    display: inline-flex;\n    width: 100%;\n\n    form {\n        width: 100%;\n    }\n\n    ion-buttons {\n        height: 38px;\n    }\n\n    .within_tag {\n        display: inline-flex;\n        justify-content: space-between;\n        background: #d2b094;\n        color: #fff2e6;\n        padding: 8px;\n        margin-top: 2px;\n        margin-left: 10px;\n        box-sizing: border-box;\n        border-radius: 4px;\n        grid-gap: 6px;\n        height: fit-content;\n        cursor: pointer;\n\n        label {\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            max-width: 113px;\n        }\n\n        ion-icon {\n            color: #fff2e6;\n            font-size: 16px !important;\n            padding-top: 0;\n        }\n    }\n}\n\n.search-results {\n    position: absolute;\n    width: 81%;\n    left: 0;\n    right: 0;\n    display: block;\n    margin: auto;\n    top: 64px;\n    z-index: 9000;\n    border-radius: 10px;\n\n    ion-list {\n        border-radius: 6px;\n\n        ion-item {\n            --inner-border-width: 0 !important;\n            background: #ede2d6 !important;\n            cursor: pointer;\n\n            ion-label {\n                color: #aaa5a1 !important;\n                white-space: no-wrap;\n            }\n        }\n    }\n}\n\n.dimmer {\n    position: absolute;\n    z-index: 9000;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.3);\n}\n\n.setSuggestionWrapper {\n    margin-top: 5vh;\n    text-align: left;\n\n    .searchPlace {\n        width: 100%;\n        display: inline-flex;\n        justify-content: space-between;\n\n        button {\n            padding: 8px;\n            margin: 0px;\n            height: fit-content;\n            border-radius: 3px;\n            font-size: 10px;\n            margin-top: 10px;\n            background: #cab0a5;\n            color: #fff5ea;\n        }\n\n        h3 {\n            font-size: 12px;\n            margin-left: 10px;\n        }\n    }\n\n    .setSuggestion {\n        text-align: left;\n        background: #fff2e6;\n        color: #a0776b;\n        border: 1px dotted #d2b094;\n        border-left: 4px solid;\n        border-right: 4px solid;\n        margin: 3px 0;\n        padding: 18px;\n        border-radius: 4px;\n        display: inline-flex;\n        width: 100%;\n        justify-content: space-between;\n        opacity: 0.7;\n        cursor: pointer;\n\n        ion-label {\n            font-weight: 900;\n\n            ion-icon {\n                width: 30px;\n                font-size: 21px;\n            }\n        }\n\n        label {\n            cursor: pointer;\n        }\n    }\n}\n\n.caretDown {\n    font-size: 21px !important;\n    padding-top: 7px;\n    width: 50px;\n}\n\n.empty_block {\n    height: 100px;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
